import * as React from "react";
import * as _ from "lodash";
import { connect, Dispatch } from "react-redux";
import { IApplicationState, AppActionCreators, ICenterListResponse, IRccapStatusListResponse, RccapActionCreators, CenterActionCreators } from "@nkr/store/index";
import { FormControl, ToggleButtonGroup, ToggleButton, Button } from "react-bootstrap";
import RccapList from "./rccap-list";
import { IListItem, ICenter } from "@nkr/models/index";
import { RccapStatus } from "@nkr/enums/index";
import { ColumnApi, CsvExportParams, GridApi, GridReadyEvent, ProcessCellForExportParams } from "ag-grid-community";

interface IOwnProps { }

interface IStateProps {
    centerList: ICenter[],
    rccapStatusList: IListItem[]
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getRccapStatusList: () => Promise<IRccapStatusListResponse>,
    getCenterList: () => Promise<ICenterListResponse>
}

type TProps =
    IOwnProps
    & IStateProps
    & IDispatchProps;

interface IState {
    status: number,
    centerId: number
}

class RccapContainer extends React.Component<TProps, IState> {
    readonly state: IState = {
        status: RccapStatus.PendingResponse,
        centerId: 0
    }


    gridApi: GridApi = null;
    gridColumnApi: ColumnApi = null;

    onGridReady = (e: GridReadyEvent) => {
        this.gridApi = e.api;
        this.gridColumnApi = e.columnApi;

        // this.showHideColumns();
    }

    componentDidMount = () => {
        this.getData();
    }

    handleStatusChange = (status: number) => {
        this.setState({
            status
        });
    }

    handleCenterChange = (e: React.ChangeEvent<FormControl & HTMLSelectElement>) => {
        this.setState({
            centerId: parseInt(e.currentTarget.value)
        });
    }

    private getData = () => {
        this.props.showLoading("Getting search data, one moment please...").then(() => {
            Promise.all([
                this.props.getRccapStatusList(),
                this.props.getCenterList()
            ])
                .then(() => {
                    this.props.hideLoading();
                });
        });
    }

    handleExport = () => {
        let params: CsvExportParams = {
            columnGroups: true,
            fileName: 'rccaps.csv',
            processCellCallback: (params: ProcessCellForExportParams) => {

                return params.value;
            }
        };

        this.gridApi.exportDataAsCsv(params);
    }

    render = () => {
        const centerList = _.orderBy(this.props.centerList, (center) => {
            return center.alias
        });

        return (
            <>
                <div className="container-fluid">
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", height: 30, marginBottom: 20 }}>
                        <div style={{ fontSize: 28, fontWeight: 500 }}>
                            RCCAPs
                        </div>
                        <div>
                            <a href="/admin/rccap/0" className="btn btn-link">Add RCCAP</a>
                        </div>
                    </div>

                    <div style={{ display: "flex", alignItems: "center", marginBottom: 20 }}>
                        <div style={{ display: "flex", alignItems: "center", marginRight: 20 }}>
                            <div style={{ marginRight: 5 }}>Status:</div>
                            <div>
                                <ToggleButtonGroup type="radio" name="swaps" value={this.state.status}>
                                    <ToggleButton type="radio" value={1} className={this.state.status == 1 ? "btn-primary" : ""} onClick={() => this.handleStatusChange(1)}>Pending Response</ToggleButton>
                                    <ToggleButton type="radio" value={2} className={this.state.status == 2 ? "btn-primary" : ""} onClick={() => this.handleStatusChange(2)}>Pending NKR</ToggleButton>
                                    <ToggleButton type="radio" value={5} className={this.state.status == 5 ? "btn-primary" : ""} onClick={() => this.handleStatusChange(5)}>Completed</ToggleButton>
                                    <ToggleButton type="radio" value={6} className={this.state.status == 6 ? "btn-primary" : ""} onClick={() => this.handleStatusChange(6)}>Draft</ToggleButton>
                                </ToggleButtonGroup>
                            </div>
                        </div>

                        <div style={{ display: "flex", alignItems: "center" }}>
                            <div style={{ marginRight: 5 }}>Center:</div>
                            <div>
                                <FormControl
                                    componentClass="select"
                                    value={this.state.centerId}
                                    onChange={this.handleCenterChange}
                                >
                                    <option value={0}>- All Centers -</option>
                                    {centerList.map((center, index) =>
                                        <option key={index} value={center.id}>{center.alias}</option>
                                    )}
                                </FormControl>
                            </div>
                        </div>
            
                        <div style={{ marginLeft: '50%', float: 'right', display: 'flex' }}>
                            <Button bsStyle='primary' onClick={this.handleExport}>Export CSV</Button>
                        </div>
                     
                    </div>

                </div>

                <RccapList
                    centerId={this.state.centerId}
                    status={this.state.status}
                    onGridReady={this.onGridReady}
                />
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        centerList: appState.centers.list,
        rccapStatusList: appState.rccap.lookupData.rccapStatusList
    };
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => { return dispatch(AppActionCreators.showLoadingAsync(message)); },
        hideLoading: () => { dispatch(AppActionCreators.hideLoading()); },
        getRccapStatusList: () => { return dispatch(RccapActionCreators.getRccapStatusList()); },
        getCenterList: () => { return dispatch(CenterActionCreators.getCenterList()); }
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(RccapContainer)